export const subjectTypes = [
  { id: 1, value: 'Pravna osoba' },
  { id: 2, value: 'Fizička osoba' },
];

export const applicantPartyTypes = [
  { id: 1, value: 'Podnositelj' },
  { id: 2, value: 'Opunomoćenik podnositelja' },
];

export const partyTypes = [
  { id: 1, value: 'Stranka' },
  { id: 2, value: 'Opunomoćenik stranke' },
];

export const fileInsight = [
  { id: 1, value: 'Stranka se odazvala uvidu u spis' },
  { id: 2, value: 'Stranka se nije odazvala uvidu u spis' },
];

export enum SUBJECT_TYPE_ENUM {
  'PRAVNA_OSOBA' = 1,
  'FIZICKA_OSOBA' = 2,
  'OBRT' = 3,
  'SLOBODNA_DJELATNOST' = 4,
  'OPG' = 5,
}

export enum APPLICANT_PARTY_TYPE_ENUM {
  'PODNOSITELJ' = 1,
  'OPUNOMOCENIK_PODNOSITELJA',
}

export enum PARTY_TYPE_ENUM {
  'STRANKA' = 1,
  'OPUNOMOCENIK_STRANKE',
}

export enum WRITTEN_STATEMENT_TYPE_ENUM {
  'PISANA_IZJAVA_IZVODACA' = 1,
  'PISANA_IZJAVA_GLAVNOG_IZVODACA' = 2,
}

export enum IPS_REGISTAR {
  'OIB_PO' = 1,
  'MBO' = 2,
  MIBPG = 3,
  MB = 4,
  RBO = 5,
  OIB_PO2 = 6,
}
